import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface StatusLabelProps {
  text: string
  statusType: 'INFO' | 'WARNING'
}

const StatusLabel: React.FC<StatusLabelProps> = ({ text, statusType }) => {
  const translate = useTranslate()

  const styles = {
    INFO: {
      backgroundColor: '#FFF4CF',
      color: '#856700',
    },
    WARNING: {
      backgroundColor: '#FAD4D4',
      color: '#A94442',
    },
  }

  return (
    <span
      css={css`
        margin-left: 10px;
        display: inline-block;
        padding: 2px 4px;
        border-radius: 5px;
        font-weight: 500;
        font-size: 12px;
        gap: 1px;
        background-color: ${styles[statusType].backgroundColor};
        color: ${styles[statusType].color};
      `}
    >
      {translate(text)}
    </span>
  )
}

export default StatusLabel
